import TodoItem from "@/domain/entities/TodoItem";
import { TodoItem as TodoItemSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const userTodoMapper = (userTodo: TodoItemSDK): TodoItem =>
    new TodoItem({
        id: userTodo.id,
        internetMessageId: userTodo.internetMessageId,
        taskSummary: userTodo.taskSummary,
        linkedEventId: userTodo.linkedEventId,
        done: userTodo.done,
        isUserAccepted: userTodo.isUserAccepted,
        checkedDate: userTodo.checkedDate,
    });

export default userTodoMapper;
